import React, { Component } from 'react';
import { connect } from 'react-redux';
import Radium from 'radium';
import { routeActions  } from 'redux-simple-router';
import { semanticColors, greyScaleColors } from '../../Globals/styles';
import animations from '../../Globals/animations';
import {generateRegisterActivityUrl} from '../../Util/urlhelper';
import { isDatesSameDay } from '../../Util/dateTime';
import { attemptGetActivities } from '../ActivityOverview/actions';

//TODO
//update total registreret i kanban

class RegisterActivities extends Component{
  constructor(props) {
    super(props);
    this.state = {
      currentActive: null,
      minIndex: 0,
      maxIndex: 6,
      tabActivities: [],
      pageToGoTo: -1
    }
  }
  componentWillMount = () => {
    const { activities, sortedActivities } = this.props;
    //if there is no activities, fetch them
    if (!sortedActivities.length){
      this.props.dispatch(attemptGetActivities(this.props.params.projectNumber))
    }
    //else create the tab activities
    else{
      this.createTabActivities(activities, sortedActivities)
    }
  };
  componentWillReceiveProps = (nextProps) => {
    //if finished fetching new activities, create the tabs
    if(nextProps.sortedActivities.length !== this.props.sortedActivities.length ||
        !isDatesSameDay(nextProps.date, this.props.date)){
      this.createTabActivities(nextProps.activities, nextProps.sortedActivities)
    }

  };
  createTabActivities = (activities, sortedActivities) => {
    let tabActivities = [];
    sortedActivities.forEach((activityId) => {
      if(!activities[activityId]) {
        return null;
      }
      //if activity has unregistered
      if(activities[activityId].pool || activityId === this.props.params.activityId){
        tabActivities.push(activityId)
        //if the activity is the activity chosen save the index as currentActive
        if(activityId === this.props.params.activityId){
          //if the active activity is indexed higher than the maxIndex value, make the max and min index values larger.
          if(tabActivities.length-1 > this.state.maxIndex){
            this.setState({
              maxIndex: this.state.maxIndex + ((tabActivities.length-1) - this.state.maxIndex),
              minIndex: this.state.minIndex + ((tabActivities.length-1) - this.state.maxIndex)
            })
          }
          else if(tabActivities.length-1 < 7){
            this.setState({
              maxIndex: 6,
              minIndex: 0
            })
          }
          this.setState({
            currentActive: tabActivities.length-1
          })
        }
      }
    })
    this.setState({
      tabActivities: tabActivities
    })
  };

  onClickTab = (indexOfTab) => {
    this.props.dispatch(routeActions.push(generateRegisterActivityUrl(this.props.params.projectNumber, this.state.tabActivities[indexOfTab])))
    this.setState({
      currentActive: indexOfTab,
      pageToGoTo: indexOfTab !== this.state.currentActive ? this.state.pageToGoTo -1 : this.state.pageToGoTo
    })
  };
  createTabNodes = () => {
    const { activities } = this.props;
    let tabNodes = []
    this.state.tabActivities.forEach((activityId, index) => {
      //if there is too many activities cut them off with max and min numbers.
      if(this.state.minIndex > index || this.state.maxIndex < index) return;

      tabNodes.push(
        <div key={activityId}
          className="waves-btn"
          onClick={()=>this.onClickTab(index)}
          style={[
            styles.tab,
            this.state.currentActive === index && styles.activeTab,
            activities[activityId].pool > activities[activityId].today && styles.hasPool
          ]}>
          {activities[activityId].name}
        </div>
        )
    })
    return tabNodes;
  };
  onClickLeftArrow = () => {
    let currentActive = this.state.currentActive;
    if(this.state.currentActive === this.state.maxIndex){
      currentActive = currentActive-1;
      this.props.dispatch(routeActions.push(generateRegisterActivityUrl(this.props.params.projectNumber, this.state.tabActivities[this.state.currentActive-1])))
    }
    this.setState({
      currentActive: currentActive,
      minIndex: this.state.minIndex-1,
      maxIndex: this.state.maxIndex-1
    })
  };
  onClickRightArrow = () => {
    let currentActive = this.state.currentActive;
    if(this.state.currentActive === this.state.minIndex){
      currentActive = currentActive+1;
      this.props.dispatch(routeActions.push(generateRegisterActivityUrl(this.props.params.projectNumber, this.state.tabActivities[this.state.currentActive+1])))
    }
    this.setState({
      currentActive: currentActive,
      minIndex: this.state.minIndex+1,
      maxIndex: this.state.maxIndex+1
    })
  };
  render()  {
    const { dispatch } = this.props;
    return (
      <div style={styles.view}>
        <div style={styles.container} className="container-fluid">

          <div style={styles.tabContainer} className="tab">

            <div className="waves-btn" style={[styles.arrows, styles.arrowLeft, this.state.minIndex === 0 && styles.arrowHide]}>
              <i
                className="fa fa-angle-left"
                aria-hidden="true"
                style={[styles.angle, this.state.minIndex === 0 && styles.angleHide]}
                onClick={this.onClickLeftArrow}
                ></i>
            </div>
            {this.createTabNodes()}
            {this.state.tabActivities.length > 7 ?
              <div className="waves-btn" style={[styles.arrows, styles.arrowRight, this.state.maxIndex === this.state.tabActivities.length-1 && styles.arrowHide]}>
                <i
                  className="fa fa-angle-right"
                  aria-hidden="true"
                  style={[styles.angle, this.state.maxIndex === this.state.tabActivities.length-1 && styles.angleHide]}
                  onClick={this.onClickRightArrow}
                  ></i>
              </div>:
            null}
          </div>
          <i
            onClick={() => dispatch(routeActions.go(this.state.pageToGoTo))}
            className="fa fa-times waves-icon"
            style={styles.closeButton}>
          </i>
          {this.props.children}
        </div>
      </div>

    )
  }
}

var styles = {
  view: {
    animation: animations.fadeIn,
    position: 'absolute',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',
    width: '100%',
    minWidth: '700px',
    height: '100%',
    minHeight: '750px',
    zIndex: '1000',
    margin: 'auto',
    paddingTop: '50px',
    backgroundColor: semanticColors.mainBackground
  },
  container:{
    height: '100%'
  },
  heading: {
    textAlign: 'center',
    width: '170px',
    height: '40px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginTop: '-40px',
    backgroundColor: semanticColors.default,
    lineHeight: '40px',
    padding: '0 12px',
    borderRadius: '2px'
  },
  closeButton: {
    cursor: 'pointer',
    fontSize: '26px',
    position: 'absolute',
    top: '7px',
    right: '22px',
    color: semanticColors.text,
    height: '36px',
    width: '36px',
    lineHeight: '36px'
  },
  tabContainer: {
    position: 'absolute',
    top: '0px',
    left: '0',
    cursor: 'pointer'
  },
  tab: {
    float: 'left',
    width: '120px',
    marginTop: '15px',
    height: '35px',
    marginLeft: '1px',
    marginRight: '1px',
    borderRadius: '2px 2px 0 0',
    backgroundColor: greyScaleColors.greyLighter,
    fontSize: '13px',
    lineHeight: '35px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderLeft: '2px solid ' + semanticColors.success,
    borderColor: semanticColors.success,
    padding: '0 5px'
  },
  activeTab:{
    backgroundColor: semanticColors.default,
    width: '145px',
    height: '40px',
    marginTop: '10px',
    fontWeight: '600',
    lineHeight: '40px'
  },
  hasPool:{
    borderColor: semanticColors.warning
  },
  arrows:{
    width: '35px',
    height: '35px',
    transition: 'margin 0.5s',
    float: 'left',
    marginTop: '15px',
    backgroundColor: semanticColors.default,
    lineHeight: '35px',
    textAlign: 'center',
    fontSize: '24px',
    padding: '0px',
    zIndex:'0',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px'
  },
  arrowLeft:{
    borderTopLeftRadius: '16px',
    marginRight: '1px'
  },
  arrowRight:{
    borderTopRightRadius: '16px',
    marginLeft: '1px'
  },
  arrowHide:{
    marginTop: '35px'
  },
  angle:{
    transition: 'display 0.5s',
    display: 'inline-block'
  },
  angleHide:{
    display: 'none'
  }
}



function sortActivities(activityOverviewReducer){
  let sortedActivities = []
  activityOverviewReducer.activityOrganizer.forEach((activityOrganizer)=> {
    activityOrganizer.items.forEach((activityId) => {
      sortedActivities.push(activityId);
    })
  })
  return sortedActivities;
}

const selectProps = state => {
  return {
    sortedActivities: sortActivities(state.activityOverviewReducer),
    activities: state.activityOverviewReducer.activities,
    date: state.activityOverviewReducer.date
  };
}

var w = Radium(RegisterActivities)
export default connect(selectProps)(w);


// WEBPACK FOOTER //
// ./src/App/Project/RegisterActivities/index.jsx